import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { ReactLenis } from "lenis/react";
import { Toaster } from "sonner";
import Landing from "@/pages/Landing";
import Admin from "@/pages/Admin";
import Account from "@/pages/Account";
import About from "@/pages/About";
import Faq from "@/pages/Faq";
import Contact from "@/pages/Contact";
import PaymentStatus from "@/pages/PaymentStatus";
import Starfield from "@/components/Starfield";
import { AuthProvider } from "@/context/AuthContext";
import { ThemeProvider } from "@/context/ThemeContext";

function App() {
  return (
    <ThemeProvider>
    <ReactLenis root options={{ lerp: 0.08, smoothWheel: true }}>
      <div className="App grain" data-testid="app-root">
        <Starfield />
        <Toaster
          position="top-center"
          toastOptions={{
            style: {
              background: "var(--surface)",
              border: "1px solid var(--line)",
              color: "var(--text)",
              fontFamily: "Manrope, sans-serif",
            },
          }}
        />
        <div className="relative" style={{ zIndex: 10 }}>
          <BrowserRouter>
            <AuthProvider>
              <Routes>
                <Route path="/" element={<Landing />} />
                <Route path="/admin" element={<Admin />} />
                <Route path="/account" element={<Account />} />
                <Route path="/about" element={<About />} />
                <Route path="/faq" element={<Faq />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="/payment/success" element={<PaymentStatus />} />
                <Route path="/payment/cancel" element={<PaymentStatus />} />
              </Routes>
            </AuthProvider>
          </BrowserRouter>
        </div>
      </div>
    </ReactLenis>
    </ThemeProvider>
  );
}

export default App;
